enum AlarmRaiseOption {
	DefaultIgnore = 1,
	DefaultAutoHandle = 2,
	IgnoreWithStatus = 3,
}

export default AlarmRaiseOption;
